import { UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY, PROJECTTYPE_ENUM } from '@/utils/enums'
import { ActionVo } from '@/utils/actionsHandler';
import {isMatched,getClassSkuAndVersion} from '@/utils/utils';
import { FindActionAbility , FindActionAbilityByClassSkuV2,
  FindActionAbilityByClassSkuUIConfig, isSupportToggerAbility, FindConfigAbility } from '@/axios/IDevice.js'
import { getSwitchKeyNameList, getSwitchKeyNameList2 } from '@/utils/getSwitchKeyNameList.js'
import { ProfessionalOnlyMsgType } from '@/configs/index';
import { warning } from '@/assets/js/common.js'
import { postWebIOSocket } from '@assets/socket';

const actionMixins = {
  data() {
    return {
      UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY,
      dialogHcl: false,
      dialogIfttt: false,
      dialogIfttt2: false,
      dialogAction: false, // action的设备选择页
      actionPannel: false, // 设备的action选择
      centerDialogVisible: false, // 延时弹窗
      dialogVisible: false,
      iftttReverseVisible:false,
      is_click: false,
      blueTittle: '',
      addDevicesTemp: [],
      delayOption: [], // 选中的延时集合
      gpDetails: [],
      optionsAdd: [
        {
          value: 'b',
          label: this.$t('iftttset.doswitchifttt')
        },
        {
          value: 'c',
          label: this.$t('iftttset.doscene')
        },
        {
          value: 'f',
          label: this.$t('iftttset.areacontrol')
        },
        {
          value: 'd',
          label: this.$t('iftttset.device')
        },
        {
          value: 'e',
          label: this.$t('iftttset.delay')
        }
      ],
      deviceAction: [], // 选中的action设备
      actionlist: [], // action的设置集合
      allactionlist: [], // 就执行所有的对象
      temAction: null, // 个设备的单个Action(点击单选选中)
      scenelist: [], // 选中的场景list
      switchifttt: [], // 开关自动化选中的集合
      handleifttt: [], // action执行自动化
      allUIConfig: {}, //所有UI配置
    }
  },

  methods: {
    checkRadioAction (item, index) {
      this.cur = index
      this.temAction = item
      item.ischeck = !item.ischeck
    },

    modifyDeviceAction(item) {
      this.modifyItem = item;

      item.ChildId = item.ChannelId;
      this.confirmaction([item]);
    },

    formateActionList () {
      // 给action添加索引并重新赋值
      this.allactionlist = this.allactionlist.map((item, index) => ({
        ...item,
        locationindex: index
      }));
    },

    /**
     * 排序
     */
    sortAllList () {
      this.allactionlist.sort((a, b) => {
        return a.locationindex - b.locationindex
      })
    },

    upmove (index) {
      // 上移
      this.allactionlist[index].locationindex = index - 1
      this.allactionlist[index - 1].locationindex = index
      this.sortAllList()
    },

    downmove (index) {
      // 下移
      this.allactionlist[index].locationindex = index + 1
      this.allactionlist[index + 1].locationindex = index
      this.sortAllList()
    },

        /**
     * 自动化 - 执行对象添加按钮是否显示
     */
    actionObjAdddataShow () {
      if (this.allactionlist.length >= this.$store.state.deployParamter.ifttt.actionshowtotal) {
        return false
      }
      return true
    },

    /**
     * 自动化详情 - 数据格式化
     */
    eidtorAllActionList() {
      this.allactionlist = []
      const templist = this.iftttmodel.ExecuteTaskList
        .map((item, index) => {
          const baseItem = { locationindex: index, IsDel: item.IsDel };
          
          item.locationindex = index;
          
          switch (item.ActionType) {
            case 1: {
              const result = parseInt(item.DelayTime) || 0;
              const time = [
                Math.floor(result / 3600),
                Math.floor((result % 3600) / 60),
                result % 60
              ].map(v => v.toString().padStart(2, '0')).join(':');
              
              return { ActionType: 1, ...baseItem, time };
            }
            
            case 3:
            case 7:
              return {
                IFT_ID: item.IFtttNo,
                IFT_Name: item.IFtttName,
                ActionType: item.ActionType,
                IsEnable: item.IsEnable,
                ...baseItem
              };
              
            case 4:
              return {
                SceneName: item.SceneName,
                SceneNo: item.SceneNo,
                ActionType: 4,
                ...baseItem
              };
            
            case 6:
              this.tempareaactionformat({ ...item, locationindex: index });
              return null;
              
            case 8:
              return {
                HCLId: item.HCLId,
                HCLName: item.HCLName,
                ActionType: 8,
                IsEnable: item.IsEnable,
                ...baseItem
              };
              
            default:
              return null;
              // return { ...item, ...baseItem };
          }
        })
        .filter(item => item !== null);
      
      this.allactionlist.push(...templist);
      this.sortAllList();
      this.getAllActionAbility();
    },

    tempareaactionformat(param) {
      if (!param?.Values?.length) return;
      
      const { ProjectType } = this.$store.state.projectinfor;
      const isAgriculture = ProjectType === PROJECTTYPE_ENUM.Agriculture;
      
      // 构建基础模型
      const model = {
        Gpno: param.Gpno,
        AreaName: param.AreaName,
        ActionType: param.ActionType,
        locationindex: param.locationindex,
        IsDel: param.IsDel,
        IsInOtherArea: param.IsInOtherArea,
        ActionList: [],
        showControlModeRadio: param.Values.every(v => v.ChannelId === 65535) ? '1' : '2'
      };
      
      this.controlModeRadio = model.showControlModeRadio;
      
      // 构建动作列表
      model.ActionList = param.Values
        .map(value => {
          // 查找匹配的控制项
          const controlItem = this.filteredAreaControlActionList.find(item => {
            if (isAgriculture && this.controlModeRadio === '2') {
              return item.ControlType === value.ControlType && item.ChannelId === value.ChannelId;
            }
            return item.ControlType === value.ControlType;
          });
          
          if (!controlItem) return null;
          
          // 创建动作对象
          const valueTemplate = controlItem.Values?.[0] || {};
          
          // 格式化值
          let defaultValue;
          if (controlItem.ControlType === 2) {
            defaultValue = '#' + value.Value.toString(16);
          } else if (controlItem.ControlType === 10) {
            defaultValue = String(value.Value);
          } else {
            const actionVo = new ActionVo({
              ...valueTemplate,
              DefaultValue: value.Value
            });
            
            if (ActionVo.isLight(actionVo) || ActionVo.isColorPanel(actionVo)) {
              value.Value = actionVo.Value;
            }
            
            defaultValue = value.Value;
          }
          
          return {
            MsgType: controlItem.MsgType,
            ShowMode: -1,
            Desc: controlItem.Desc,
            ischeck: controlItem.ischeck,
            Values: [{
              KeyId: valueTemplate.KeyId,
              ValueType: valueTemplate.ValueType,
              Name: valueTemplate.Name,
              Min: valueTemplate.Min,
              Max: valueTemplate.Max,
              EnumValue: valueTemplate.EnumValue,
              IsShow: valueTemplate.IsShow,
              Type: valueTemplate.Type,
              DefaultValue: defaultValue
            }],
            ControlType: controlItem.ControlType,
            ChannelId: controlItem.ChannelId,
            ControlName: controlItem.ControlName
          };
        })
        .filter(action => action !== null);
      this.allactionlist.push(model);
      this.areaActionTempListDefault();
    },

    /**
     * 批量获取编辑状态下设备的能力表
     */
    async getAllActionAbility() {
      const allDevice = this.iftttmodel.ExecuteTaskList.filter(item => item.ActionType === 0);

      const list = getClassSkuAndVersion(allDevice);

      if (!list.length) return;

      await this.getClassSkuUIConfig(list);

      const res = await FindActionAbilityByClassSkuV2(list);

      if (res?.StatusCode === this.$store.state.rightStatusCode) {
        this.functionEditorDoFindActionAbility(res.Result, allDevice);
      }
    },

    /**
     * 开关翻转演示时间
     * @param {*} info 
     * @param {*} allDevice 
     */
    iftttReverseDelay(){     
      this.iftttReverseDelayTime[this.modifyItem.IFT_ID] = {} 

      if (!this.iftttReverseDelayChecked) {
        this.iftttReverseDelayTime[this.modifyItem.IFT_ID] = {} 
        this.iftttReverseVisible = false
        return;
      }

      this.iftttReverseVisible = false
      this.iftttReverseDelayTime[this.modifyItem.IFT_ID].hour = +this.iftttReverseValue1 || 0
      this.iftttReverseDelayTime[this.modifyItem.IFT_ID].minute = +this.iftttReverseValue2 || 0
      this.iftttReverseDelayTime[this.modifyItem.IFT_ID].second = +this.iftttReverseValue3 || 0

      if(
        this.iftttReverseDelayTime[this.modifyItem.IFT_ID].hour === 0 && 
        this.iftttReverseDelayTime[this.modifyItem.IFT_ID].minute === 0 && 
        this.iftttReverseDelayTime[this.modifyItem.IFT_ID].second === 0
      ) {
        this.iftttReverseDelayTime[this.modifyItem.IFT_ID] = {} 
        this.iftttReverseDelayChecked = false
      }
    },

    async functionEditorDoFindActionAbility(info, allDevice) {
      try {
        allDevice.forEach((item, index) => {
          const findInfo = info.find(res => res.ClassSku === item.ClassSku && res.FirmVersions.includes(item.LocalVersion));

          if (!findInfo) return;

          const actionList = JSON.parse(JSON.stringify(findInfo.ActionList))
          const rsActionList = actionList.filter(item => this.getIftttShowMode(item))
          const currentAction = {
            AreaName: item.AreaName, 
            ChannelId: item.ChannelId, 
            DeviceName: item.DeviceName,
            VDeviceId: item.VDeviceId, 
            ChannelName: item.ChannelName, 
            locationindex: item.locationindex,
            ActionList: [], 
            ClassSku: item.ClassSku, ActionType: 0
          }
          const processAction = (actions, add = true) => {
            actions.forEach(n => {
              const sameTypeList = rsActionList.filter(action => action.MsgType === n.MsgType)
              if (!sameTypeList.length) return
              
              n.Values.forEach(t => {
                sameTypeList.forEach(m => {
                  m.Values.forEach((p, idx) => {
                    if (t.KeyId !== p.KeyId) return
                    
                    const actionVo = new ActionVo({...p, DefaultValue: t.Value})
                    if (ActionVo.isLight(actionVo) || ActionVo.isColorPanel(actionVo)) m.Values[idx] = actionVo
                    
                    if (p.ValueType === 'UIControl_RGB_Color_Multiple_Choose') p.DefaultValue = t.Value
                    else if (p.ValueType === 'UIControl_MultipleDropdownList') p.DefaultValue = t.Value.split(',')
                    else if (p.ValueType === 'UIControl_ColorPanel' || UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY.includes(p.ValueType)) p.DefaultValue = t.Value
                    else if (p.ValueType === 'UIControl_TianMu_PlaybackSpeed_Group') p.DefaultValue = t.Value / 10
                    else p.DefaultValue = Number(t.Value)
                    
                    this.handlerStepActionItem(m.Values[idx])
                  })
                })
              })
              
              if (add) currentAction.ActionList.push(...sameTypeList)
            })
          }
          
          processAction(item.ActionList);

          if (item.BackupActionList) processAction(item.BackupActionList, false)
          
          currentAction.ActionList = currentAction.ActionList.filter(item => isMatched(item, rsActionList, 2))
          currentAction.allActionlist = rsActionList

          this.deviceAction.push(currentAction)
          
          this.allactionlist.push(currentAction)
          
          if (this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture) {
            getSwitchKeyNameList({
              allactionlist: this.allactionlist,
              ChannelSkus: Object.keys(this.$store.state.staticConfig.ChannelNameConfig)
            })
          }
        })
        this.sortAllList();
      } catch (error) {
        console.log('批量获取action能力表失败', error)
      }
    },

    /**
     * 选中设备回显能力
     */
    async actionPannelmethods(list, param) {
      this.actionlist = []
      
      if (list.some(item => item.UI?.ActionDisabledBySettings?.[0])) {
        const res = await FindConfigAbility({ vDeviceId: this.temdevice.VDeviceId })
        this.gpDetails = res.Result?.GpList || []
      }
      
      if (!list.length) return
      
      list.forEach(n => {
        if (!this.getIftttShowMode(n)) return
        
        let num = 0
        n.hasName = false
        
        n.Values.forEach((v, i) => {
          if (v.IsShow) num++
          this.handlerStepActionItem(v)
          
          n.Values[i] = new ActionVo(v)
          
          const val = n.Values[i]
          if (val.ValueType === 'UIControl_ChooseRange') val.DefaultValue = [val.Min, val.Max]
          else if (val.ValueType === 'UIControl_MultipleDropdownList') val.DefaultValue = val.DefaultValue.split(',')
          else if (['UIControl_RGB_Color_Multiple_Choose', ...UICONTROL_CX_CY_Multiple_CHOOSE_ARRAY].includes(val.ValueType)) val.DefaultValue = val.DefaultValue
          else val.DefaultValue = Number(val.DefaultValue)
        })
        
        if (num > 1) n.hasName = true
        n.ischeck = false
        this.actionlist.push(n)
      })
      
      if (param && this.modifyItem && 
          param.vDeviceId === this.modifyItem.VDeviceId && 
          (param.ChildId === this.modifyItem.ChildId || param.ChildId === this.modifyItem.ChannelId)
        ) {
        if (list.length && this.modifyItem.ActionList?.length) {
          this.deviceActionFilter(this.actionlist, this.modifyItem.ActionList)
          if (this.modifyItem.allActionlist) {
            const otherList = this.modifyItem.allActionlist.filter(item => 
              !this.modifyItem.ActionList.some(_item => _item.MsgType === item.MsgType)
            )
            this.deviceActionFilter(this.actionlist, otherList, false)
          }
        }
      }
      
      if (this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture) {
        const { ClassSku, VDeviceId } = this.temdevice
        const batchSetAgricultureChannelSkus = Object.keys(this.$store.state.staticConfig.ChannelNameConfig)
        if (batchSetAgricultureChannelSkus.includes(ClassSku)) {
          getSwitchKeyNameList2({ VDeviceId, actionlist: this.actionlist })
        }
      }
    },

    handlerStepActionItem(currentItem) {
      if (Number.isInteger(currentItem.UI?.step) && currentItem.UI.AppUnit && currentItem.isHandlerStep !== true) {
        currentItem.ParaUnit = currentItem.UI.AppUnit;
        currentItem.Max = Math.ceil(currentItem.Max / currentItem.UI.step);
        currentItem.Min = Math.ceil(currentItem.Min / currentItem.UI.step);
        currentItem.isHandlerStep = true;
        currentItem.DefaultValue = Math.ceil(Number(currentItem.DefaultValue) / currentItem.UI.step);
      }
    },

    /**
     * 获取能力表的排序UI配置 
     */
    async getClassSkuUIConfig(list){
      const info = await FindActionAbilityByClassSkuUIConfig(list);
      // 获取所有的UI配置
      if (info.StatusCode === this.$store.state.rightStatusCode) {
          info.Result.forEach(item => {
            if(item.UIContent && item.UIContent.WebUIConfigV2){
              this.allUIConfig[item.ClassSku] = item.UIContent.WebUIConfigV2
            }
        })  
      }
    },

    modifyTimeAction(item) {
      this.modifyItem = item;
      
      // 解析时间字符串
      if (item?.time) {
        const [h = '00', m = '00', s = '01'] = item.time.split(':');
        this.value1 = h;
        this.value2 = m;
        this.value3 = s;
      }
      
      // 打开对话框
      this.centerDialogVisible = true;
      this.blueTittle = this.$t('iftttset.delayset');
    },

    cancledelayTime () {
      this.centerDialogVisible = false
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''
    },

    delayTimeAdd () {
      if (this.value1 === '' || this.value2 === '' || this.value3 === '') {
        warning(this, this.$t('iftttset.SelectDelayTime'))
        return
      }

      if (this.modifyItem != null) {
        this.modifyItem.time = this.value1 + ':' + this.value2 + ':' + this.value3
      } else {
        this.delayOption.push(this.value1 + ':' + this.value2 + ':' + this.value3)
        // ActionType-1 标识定时
        const para = { ActionType: 1, time: this.value1 + ':' + this.value2 + ':' + this.value3 }
        debugger
        this.allactionlist.push(para)
      }
      this.formateActionList()
      this.centerDialogVisible = false
      this.value1 = ''
      this.value2 = ''
      this.value3 = ''
    },

    handleAddSet(command) {
      const actions = {
        a: () => {
          if (this.triggermanual.length === 0) {
            this.dialogIfttt = true
            this.is_click = false
          } else {
            warning(this, this.$t('iftttset.nodoiftttwarning'))
          }
        },
        b: () => {
          this.dialogIfttt2 = true
          this.is_click = true
          this.checkShow = false
        },
        c: () => {
          this.dialogVisible = true
        },
        d: () => {
          if (this.isVisual) {
            this.$emit('openDiveceList', 'action', this.allactionlist)
            return
          }
          this.dialogAction = true
        },
        e: () => {
          this.value1 = '00'
          this.value2 = '00'
          this.value3 = '01'
          this.centerDialogVisible = true
          this.blueTittle = this.$t('iftttset.delayset')
        },
        f: () => {
          this.temparealist = []
          this.tempareacheckedarea = []
          this.dialogAreaSelect = true
          this.areaActionTempListDefault()
        },
        h: () => {
          this.dialogHcl = true
        }
      }
      
      if (actions[command]) {
        actions[command]()
      }
    },
    delAction (index) {
      this.delallList(index)
    },

    async confirmaction (devices) {
      //选择设备
      this.addDevicesTemp = devices;
      // action选择好设备以后处理
      postWebIOSocket('sync_info_removeall_event')
      this.temdevice = devices[0]
      this.iftttPlantId = await this.handleTianMuInIfttt({ActionList:devices[0]?.allActionlist || devices[0].ActionList, VDeviceId:devices[0].VDeviceId})
      this.doFindActionAbility()
    },

    confirmIfttt (val) {
      // action选择好开关自动化
      this.switchifttt = val
      if (val.length > 0) {
        val.forEach(n => {
          n.ActionType = 3
          debugger
          this.allactionlist.push(n)
        })
      }
      this.dialogIfttt2 = false
      this.formateActionList()
    },

    doFindActionAbility () {
      let para = { vDeviceId: this.temdevice.VDeviceId, ChildId: this.temdevice.ChildId ?? this.temdevice.ChannelId };
      
      FindActionAbility(para, this.functionDoFindActionAbility)
      
      this.dialogAction = false;
      this.$emit('doFindActionAbility');
    },

    /**
     * 编辑设备action后,获取设备的触发能力
     */
    async functionDoFindActionAbility (rs, param) {
      if (!this.$store.state.isProfessional) {
        rs.Result.ActionList = rs.Result.ActionList.filter(item => !ProfessionalOnlyMsgType.includes(item.MsgType));
      }

      if (rs.Result.ActionList) {
        this.cur = -1;

        this.actionPannelmethods(rs.Result.ActionList, param);

        const { ClassSku,LocalVersion} = this.temdevice;

        await this.getClassSkuUIConfig([{ClassSku,FirmVersions:[LocalVersion]}]);
        
        //选择视频场景从这里获取能力，不需要弹本身能力弹窗
        this.actionPannel = true && !this.TianmuIsShow
      }
    },

    delallList (index) {
      const [ spliceItem ] = this.allactionlist.splice(index, 1);
      if(spliceItem.ActionType === 3){
        this.iftttReverseDelayTime[spliceItem.IFT_ID] = {}
      }
    
      this.deviceOption = this.deviceOption.filter(item => 
        item.VDeviceId !== spliceItem.VDeviceId &&
        item.DeviceName !== spliceItem.DeviceName
      )
      
      this.delsuccess()
      this.formateActionList()
    },

    confirmIfttthandle (val) {
      // action选择好手动执行
      if (val.length > 0) {
        val.forEach(n => {
          this.allactionlist.forEach((m, index) => {
            if (m.ActionType === 7 && m.IFT_ID === n.IFT_ID) {
              this.allactionlist.splice(index, 1)
            }
          })
          n.ActionType = 7
          debugger
          this.allactionlist.push(n)
        })
      }
      this.handleifttt = val
      this.formateActionList()
      this.dialogIfttt = false
    },

    eidtorIftttformate () {
      // ifttt开关编辑初始化数据
      this.iftttmodel.ExecuteTaskList.forEach(n => {
        if (n.ActionType === 3) {
          this.reverseAutomationTime(n.IFtttNo,n.IftttToggleInterval)
          this.switchifttt.push({
            IFT_ID: n.IFtttNo,
            IFT_Name: n.IFtttName,
            IsEnable: n.IsEnable
          })
        }
      })
    },

    confirmHclhandle (val) {
      if (val.length > 0) {
        val.forEach(n => {
          n.ActionType = 8
          debugger
          this.allactionlist.push(n)
        })
      }
      this.dialogHcl = false
    },

    confirmScene(val) {
      this.dialogVisible = false
      
      val.forEach(n => {
        this.scenelist.push(n)
        
        if (n.WellSkyTemplateId !== 0 && n.SceneType === 2) {
          this.showTianmuVideo(n)
        } else {
          debugger
          this.allactionlist.push({ ...n, ActionType: 4 })
        }
      })
      
      this.formateActionList()
    },

    /**
     * 设备action选择能力弹窗确定回调
     */
    async okaction () {
      // 确定选择action
      let _tempaction = []
      const _tempList =this.actionlist
      this.actionlist.filter((item,index,array)=>{
        return isMatched(item,array,2)
      }).forEach(n => {
        if (n.ischeck) {
          _tempaction.push(n)
        }
      })

      if (_tempaction.length === 0) {
        warning(this, this.$t('iftttset.SelecAction'))
        return
      }

      const isCheck = this.checkTianmuSceneNo(_tempaction)

      if(!isCheck){
        warning(this, this.$t('tianmu.noVideo'))
        return
      }
      
      const hasItem = _tempaction.some(item => item.MsgType === "0x130F0000");  
      const ProtocolType = this.addDevicesTemp.map(item=>item.ProtocolType)
     
      // 如果存在，设置 SupportToggerVisible 为 true  
      if (hasItem && !ProtocolType.includes(1)) {  
        const VDeviceIds = this.addDevicesTemp.map(item=>item.VDeviceId)
        const FunctionTypes = ["OnOffToggle"]
        const params = { VDeviceIds, FunctionTypes }
        const res = await isSupportToggerAbility(params)
        
        if (res.StatusCode === this.$store.state.rightStatusCode) {
          const { OnOffToggle } = res.Result || [];
          const filterRes = OnOffToggle.filter(item => !item.GatewaySupport && !item.OtaGatewaySupport)
          const filterRes2 = OnOffToggle.filter(item => !item.GatewaySupport && item.OtaGatewaySupport)
          if(filterRes.length > 0){
            // 都不支持
            this.ifttt3ToggerOkText = this.$t('install.getInfo');
            this.isSupportToggerflag = true;
            this.SupportToggerVisible = true;  
            return;
          }
          if(filterRes2.length > 0){
            // 都不支持
            this.ifttt3ToggerOkText = this.$t('visual.toUpgrade');
            this.isSupportToggerflag2 = true;
            this.SupportToggerVisible = true;  
            return;
          }
        }
      }
    
      if (this.modifyItem != null) {
        // this.modifyItem["ActionList"] = _tempaction;
        let _curObj = this.allactionlist.find(_item => { return _item.locationindex === this.modifyItem.locationindex })
        _curObj.ActionList = _tempaction
        _curObj.allActionlist = _tempList
        _curObj = null
        this.setActionDefaultValue()

        if(this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture){
          const ChannelNameConfig = this.$store.state.staticConfig.ChannelNameConfig
          const batchSetAgricultureChannelSkus = Object.keys(ChannelNameConfig)
          getSwitchKeyNameList({
            allactionlist: this.allactionlist,
            ChannelSkus: batchSetAgricultureChannelSkus
          })
        }
      } else if (this.addDevicesTemp.length > 0) {
        const pushDevices = this.addDevicesTemp.map(device => {
          //深拷贝 避免引用类型数据被修改 ,增加allActionlist 用于后续编辑
          //为啥深拷贝,通过classsku获取actionlist时,同个clssssku的actionlist是一样的,引用地址一样,修改一个会导致其他的设备也会被修改
          //为啥增加allActionlist,因为后续编辑时,需要获取所有的actionlist,而不是只获取当前设备的选中的actionlist
          const deepList = JSON.parse(JSON.stringify(_tempList));
          let _tempaction = deepList.filter((item,index,array)=>{
            return isMatched(item,array,2)
          }).filter(n => n.ischeck);
          return {
            ActionType: 0,
            VDeviceId: device.VDeviceId,
            DeviceName: device.DeviceName,
            AreaName: device.AreaName,
            ChannelId: device.ChildId ?? device.ChannelId,
            ClassSku: device.ClassSku,
            ChannelName: device.ChildName || device.ChannelName,
            Gpno:device.Gpno,
            ActionList: _tempaction,
            allActionlist: deepList
          }
        });
        this.deviceAction = this.deviceAction.concat(pushDevices)
        debugger
        this.allactionlist = this.allactionlist.concat(pushDevices)

        if(this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture){
          const ChannelNameConfig = this.$store.state.staticConfig.ChannelNameConfig
          const batchSetAgricultureChannelSkus = Object.keys(ChannelNameConfig)
          getSwitchKeyNameList({
            allactionlist: this.allactionlist,
            ChannelSkus: batchSetAgricultureChannelSkus
          })
        }
      } else {
        let obj = {
          ActionType: 0,
          VDeviceId: this.temdevice.VDeviceId,
          DeviceName: this.temdevice.DeviceName,
          AreaName: this.temdevice.AreaName,
          ChannelId: this.temdevice.ChildId ?? this.temdevice.ChannelId,
          ClassSku: this.temdevice.ClassSku,
          ActionList: _tempaction,
          ChannelName: this.temdevice.ChildName || this.temdevice.ChannelName,
          allActionlist: _tempList
        }

        this.deviceAction.push(obj)
        debugger
        this.allactionlist.push(obj)
      }

      this.formateActionList()

      this.addDevicesTemp = [];
      this.temAction = null
      
      this.temdevice = {}

      this.actionPannel = false
      this.actionlist = []   
     
      this.modifyItemClear()
    },

    modifyallList (type, command, item, index) {
      this.modifyItem = item
      if (type == 'trigger') {
        if (command == 'a') {
          this.value1 = item
          this.value2 = ''
          this.value3 = ''
          this.timingset = true
        } else if (command == 'b') {
          this.confirm([item])
        }
      } else if (type == 'action') {
        if (command == 'd') {
          // 编辑设备动作
          item.ChildId = item.ChannelId
          this.confirmaction([item])
        } else if (command == 'e') {
          // 编辑延时
          let _time = item.time
          _time = _time && _time.split(':')
          if (_time instanceof Array) {
            this.value1 = _time[0] || '00'
            this.value2 = _time[1] || '00'
            this.value3 = _time[2] || '01'
          }
          _time = null
          this.centerDialogVisible = true
          this.blueTittle = this.$t('iftttset.delayset')
        } else if (command == 'f') {
          // 编辑区控
          this.areaActionTempListDefault()
          let _item
          if (item.ActionList instanceof Array) {

            const isChannelId = item.ActionList.every(i => !i.ChannelId || i.ChannelId === 65535);

            if(isChannelId){
              this.controlModeRadio = '1'
            }else{
              this.controlModeRadio = '2'
            }
            
            this.filteredAreaControlActionList.forEach(action => {
                if(this.$store.state.projectinfor.ProjectType === PROJECTTYPE_ENUM.Agriculture){
                  if(this.controlModeRadio === '2'){
                     _item = item.ActionList.find(_action => { return (_action.ControlType === action.ControlType && _action.ChannelId === action.ChannelId)})
                  }else{
                    _item = item.ActionList.find(_action => { return (_action.ControlType === action.ControlType) })
                  }
                }else{
                  _item = item.ActionList.find(_action => { return (_action.ControlType === action.ControlType) })
                }
              if (_item != null) {
                action.ischeck = true
                action.Values[0].DefaultValue = _item.Values[0].DefaultValue
              } else {
                action.ischeck = false
              }
            })
          }
          _item = null
          this.dialogAreaSelect = true
          this.temparealist = []
          this.tempareacheckedarea = []
          setTimeout(parm => {
            this.dialogAreaSelect = false
            this.tempareaactionPannel = true
          }, 10)
        } else if (command == 'z') {
          // 编辑开关自动化延时
          const reverseDelayTime = this.iftttReverseDelayTime?.[item.IFT_ID]
          if (reverseDelayTime && Object.keys(reverseDelayTime).length > 0) {
            this.iftttReverseValue1 = this.iftttReverseDelayTime[item.IFT_ID].hour?.toString() || '0'
            this.iftttReverseValue2 = this.iftttReverseDelayTime[item.IFT_ID].minute?.toString() || '0'
            this.iftttReverseValue3 = this.iftttReverseDelayTime[item.IFT_ID].second?.toString() || '0'
            this.iftttReverseDelayChecked = true
          } else {
            this.iftttReverseValue1 = '0'
            this.iftttReverseValue2 = '0'
            this.iftttReverseValue3 = '0'
            this.iftttReverseDelayChecked = false
          }
          this.iftttReverseVisible = true
        }
      }
    },
  },
}


export default actionMixins;